import { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { trackEvent } from "@hopper-b2b/api";
import { useGetExperimentPayload } from "@hopper-b2b/experiments";
import { getPercentage, useI18nContext } from "@hopper-b2b/i18n";
import { WalletTrackingEvents } from "@hopper-b2b/types";
import clsx from "clsx";
import { FEATURE_FLAGS } from "../../App";
import { PATH_HOTELS_SEARCH, PATH_OFFERS } from "../../utils/urlPaths";
import style from "./styles.module.scss";

interface IOfferListProps {
  offers: any; // TODO: Update type
  modal?: boolean;
  handleOpenOffersModal?: () => void;
  loading: boolean;
}

const OfferList = ({
  offers,
  modal = false,
  handleOpenOffersModal,
  loading,
}: IOfferListProps) => {
  const { t, locale } = useI18nContext();
  const navigate = useNavigate();

  const walletOfferUrls = useGetExperimentPayload(
    FEATURE_FLAGS.WALLET_OFFER_URLS
  )?.walletOfferUrls;

  const navigateToLodging = useCallback(
    (offer: any) => {
      const urlKey = walletOfferUrls[offer.name];
      // track tap before routing
      trackEvent({
        eventName: WalletTrackingEvents.tapped_offer_modal,
        properties: {
          offer_name: urlKey,
        },
      });
      navigate(`${PATH_HOTELS_SEARCH}?location=${urlKey}`);
    },
    [navigate, walletOfferUrls]
  );

  const navigateToOffers = useCallback(() => {
    handleOpenOffersModal();
    navigate(PATH_OFFERS);
  }, [handleOpenOffersModal, navigate]);

  return (
    <div className={clsx(style.offerListContainer, { modal, loading })}>
      <div className={clsx(style.offerListTitle, { modal, loading })}>
        {modal ? t("offers.chooseDestination") : t("offers.title")}
      </div>
      <div
        className={clsx(style.offerList, { singleOffer: offers?.length === 1 })}
      >
        {loading
          ? [1, 2].map((i) => (
              <div
                key={`home-offer-takeover-loader-${i}`}
                className={clsx("home-offer-takeover-list-item", { loading })}
              ></div>
            ))
          : // TODO: Update type
            offers?.map((offer: any, i: number) => {
              const formattedDiscount = getPercentage(
                offer?.discount.percentage * 100,
                locale
              );
              const { offerContent } = offer;

              return (
                <button
                  className="home-offer-takeover-list-item"
                  onClick={() => navigateToLodging(offer)}
                  key={`home-offer-takeover-list-item-${i}`}
                >
                  <div className="offer-image">
                    <img
                      className="offer-image-src"
                      src={offerContent.imageUrl}
                      alt={offerContent.title}
                    />
                    <div className="offer-tag">
                      {t("lodgingOfferDiscount.badge", {
                        discount: formattedDiscount,
                      })}
                    </div>
                  </div>
                  <div className="offer-content">
                    <div className="offer-destination">
                      {offerContent.title}
                    </div>
                    {offerContent.lineItemDescription ? (
                      <div className="offer-description">
                        {offerContent.lineItemDescription}
                      </div>
                    ) : null}
                  </div>
                </button>
              );
            })}
      </div>
      {handleOpenOffersModal ? (
        <button className={style.offerListButton} onClick={navigateToOffers}>
          {t("seeOfferDetails")}
        </button>
      ) : null}
    </div>
  );
};

export default OfferList;
